import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchAdapter {
  private http = inject(HttpClient);

  getResults(query: string, limit: number = -1): Observable<any> {
    const params = new HttpParams()
      .set('query', query)
      .set('limit', limit)
      .set('searchForApplications', true)
      .set('searchForJobs', true);

    return this.http.get(`${environment.apiBaseUrl}/company/search`, {
      params: params,
    });
  }

  getApplicationResults(query: string, limit: number = -1) {
    const params = new HttpParams()
      .set('query', query)
      .set('limit', limit)
      .set('searchForApplications', true)
      .set('searchForJobs', false);

    return this.http.get(`${environment.apiBaseUrl}/company/search`, {
      params: params,
    });
  }

  getJobResults(query: string, limit: number = -1) {
    const params = new HttpParams()
      .set('query', query)
      .set('limit', limit)
      .set('searchForApplications', false)
      .set('searchForJobs', true);

    return this.http.get(`${environment.apiBaseUrl}/company/search`, {
      params: params,
    });
  }
}
